import { FC } from 'react'
import { Link } from 'react-router-dom'

export const GotoHomeButton: FC = () => {
  return (
    <>
      <Link
        className="py-1 px-2 mt-2 inline-flex justify-center items-center rounded-md border border-transparent font-light transition-all text-xs bg-gray-200"
        to={'/'}
      >
        HOME
      </Link>
    </>
  )
}
